import { useLocation } from 'react-router-dom';
import React from 'react';

// TODO: this hook has been copied from src/ui/TabulatedPage/hooks.tsx because both components started to diverge.
// We should probably have a single tabulation logic, and compose the components to have either a button, a tab or a chip.

type TabT = {
    label: string;
    icon?: React.ReactElement;
    children: React.ReactNode;
    pathname: string;
    search?: string;
    disabled?: boolean;
    onClick?: () => void;
};

/**
 * @return { [path]: boolean } object telling for each tab if it has already been visited or not.
 */
export const useHasTabBeenVisited = (
    tabsList: TabT[],
    keepSearch: boolean = true,
): { [path: string]: boolean } => {
    const hasTabBeenVisitedInitValue = React.useMemo(() => {
        return tabsList.reduce<{
            [path: string]: boolean;
        }>(
            (result, currentTab) => ({
                ...result,
                [currentTab.pathname + (keepSearch ? currentTab.search : '')]:
                    false,
            }),
            {},
        );
    }, [tabsList, keepSearch]);

    const [hasTabBeenVisited, setHasTabBeenVisited] = React.useState<{
        [path: string]: boolean;
    }>(hasTabBeenVisitedInitValue);

    const location = useLocation();

    React.useEffect(() => {
        // if the location does not have a search part but the first tab has, we consider
        // that the visited tab is the first one.
        // We really need the OR operator here, not ??. location.search is an empty string
        // when there is no search part in the URL
        const search = location.search || tabsList[0].search || '';
        setHasTabBeenVisited((prev) => ({
            ...prev,
            [location.pathname + (keepSearch ? search : '')]: true,
        }));
    }, [location, keepSearch, tabsList]);

    return hasTabBeenVisited;
};
